import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { Divider, Link, Typography, useMediaQuery, useTheme } from "@mui/material";
import Markdown from "markdown-to-jsx";
import { CountdownTimer } from "../CutoffDate/CountdownTimer";
import { CutoffDate } from "../CutoffDate/CutoffDate";
import { CutoffTimer } from "../CutoffDate/CutoffTimer";
import { CustomTable } from "./CustomTable";
import { CustomTd } from "./CustomTd";
import { defaultTypographyHeadingStyles } from "./MuiMarkdown-utils";
import { useMarkdownStyles } from "./useMarkdownStyles";
export const MuiMarkdown_V2 = ({ align = "inherit", children, bgColor = "#fff", isTopBar = false, linkTypographyVariant = "body1", pVariant = "body1", style, sx, }) => {
    const styleProps = {
        bgColor: bgColor,
        alignment: align,
        isTopBar: isTopBar,
    };
    const theme = useTheme();
    const classes = useMarkdownStyles(styleProps);
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"), { noSsr: true });
    if (!children) {
        return _jsx(_Fragment, {});
    }
    return (_jsx(Markdown, Object.assign({ className: classes.markdownEl, options: {
            disableParsingRawHTML: true,
            overrides: {
                h1: {
                    component: Typography,
                    props: Object.assign(Object.assign({}, defaultTypographyHeadingStyles), { color: "primary", variant: "h1", align: align, style,
                        sx }),
                },
                h2: {
                    component: Typography,
                    props: Object.assign(Object.assign({}, defaultTypographyHeadingStyles), { color: "primary", variant: "h2", align: align, style,
                        sx }),
                },
                h3: {
                    component: Typography,
                    props: Object.assign(Object.assign({}, defaultTypographyHeadingStyles), { color: "primary", variant: "h3", align: align, style,
                        sx }),
                },
                h4: {
                    component: Typography,
                    props: Object.assign(Object.assign({}, defaultTypographyHeadingStyles), { color: "primary", variant: "h4", align: align, style,
                        sx }),
                },
                h5: {
                    component: Typography,
                    props: Object.assign(Object.assign({}, defaultTypographyHeadingStyles), { color: "primary", variant: "h5", align: align, style,
                        sx }),
                },
                h6: {
                    component: Typography,
                    props: Object.assign(Object.assign({}, defaultTypographyHeadingStyles), { color: "primary", variant: "h6", align: align, style,
                        sx }),
                },
                p: {
                    component: Typography,
                    props: {
                        className: "ignore-global-styles",
                        paragraph: true,
                        variant: pVariant,
                        align: align,
                        style,
                        sx,
                    },
                },
                a: {
                    component: Link,
                    props: {
                        align: align,
                        style,
                        sx: Object.assign({ textDecoration: "underline" }, sx),
                        target: "_blank",
                        variant: linkTypographyVariant,
                    },
                },
                ul: { props: { style: { paddingLeft: theme.spacing(2) }, align: align } },
                span: {
                    component: Typography,
                    props: {
                        className: "ignore-global-styles",
                        paragraph: true,
                        variant: pVariant,
                        align: align,
                        style,
                        sx,
                    },
                },
                table: { component: CustomTable, props: { align: align } },
                td: { component: CustomTd, props: Object.assign(Object.assign({}, (isMobile && { style: { textAlign: "center" } })), { align: align }) },
                CountdownTimer: { component: CountdownTimer, props: { align: align, className: classes.markdownEl } },
                CutoffTimer: { component: CutoffTimer, props: { align: align, className: classes.markdownEl } },
                CutoffDate: { component: CutoffDate, props: { align: align, className: classes.markdownEl } },
                hr: {
                    component: Divider,
                    props: {
                        style: {
                            height: "1px",
                            backgroundColor: theme.palette.primary.main,
                            border: "none",
                            margin: "1rem auto",
                        },
                    },
                },
                LeftHeading: { component: "div", props: { align: "left" } },
                CenterHeading: { component: "div", props: { align: "center" } },
                RightHeading: { component: "div", props: { align: "right" } },
            },
        } }, { children: children })));
};
